<template>
  <div class="content">
    <div class="nav nav-pills">
      <router-link
        to="/reports/repair-check-list?check=false"
        exact
        class="nav-link"
        active-class="active"
        @click.native="addKey"
        >ремонты на оценке</router-link
      >
      <router-link
        to="/reports/repair-check-list?check=true"
        exact
        class="nav-link"
        active-class="active"
        @click.native="addKey"
        >создание отчета</router-link
      >
      <router-link
        to="/reports/reports-list"
        exact
        class="nav-link"
        active-class="active"
        @click.native="addKey"
        >список отчетов</router-link
      >
    </div>
    <div class="content" :key="viewKey">
      <router-view class="view" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Reports",
  data: () => ({
    viewKey: 0
  }),
  methods: {
    addKey() {
      this.viewKey += 1;
    }
  }
};
</script>
<style lang="scss" scoped>
.active {
  color: #fff;
  background: #007bff;
  cursor: default;
  text-decoration: none;
}
.content {
  padding: 5px;
}
</style>
